import { Input } from "@/shared/ui/input";

interface WeightInputProps {
  value: string | number;
  error?: string | null;
  onChange: (value: string | number) => void;
  onErrorChange?: (error: string | null) => void;
}

export function WeightInput({
  value,
  error,
  onChange,
  onErrorChange,
}: WeightInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onErrorChange?.(null);
    onChange(e.target.value);
  };

  const handleBlur = () => {
    if (value === "" || value === "-") {
      onChange(0);
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-ink-800">
        Weight <span className="text-red-500">*</span>
      </label>
      <Input
        type="text"
        inputMode="numeric"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        className={error ? "border-red-500" : ""}
      />
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
}

